import './address-form.scss';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useWatch, useFormContext } from 'react-hook-form';
import { getDefaultCountry } from 'researcher/user/reducer';
import { T, useTranslate } from 'shared/helper/translate';
import { convertRawAddressToFormData } from 'shared/view/address-conversion-service';
var styles = {
  wrapper: 'mb-3'
};
export var defaultValues = {
  id: '',
  address1: '',
  address2: '',
  city: '',
  country: {
    value: '',
    states: []
  },
  name: '',
  organization: '',
  phone: '',
  state: '',
  zip: ''
};
var AddressForm = function AddressForm(_ref) {
  var _country$states;
  var address = _ref.address,
    addressOptions = _ref.addressOptions,
    displayHeader = _ref.displayHeader,
    enableAddressSelection = _ref.enableAddressSelection,
    name = _ref.name,
    nameField = _ref.nameField,
    organizationField = _ref.organizationField,
    organizationFieldDescription = _ref.organizationFieldDescription,
    organizationFieldErrorMessage = _ref.organizationFieldErrorMessage,
    organizationFieldLabel = _ref.organizationFieldLabel,
    organizationFieldRequired = _ref.organizationFieldRequired,
    phoneField = _ref.phoneField,
    phoneValidation = _ref.phoneValidation,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? true : _ref$required,
    selectableCountries = _ref.selectableCountries,
    philDefaultCountry = _ref.philDefaultCountry,
    type = _ref.type,
    vatField = _ref.vatField,
    zipCodeField = _ref.zipCodeField,
    _ref$Controls = _ref.Controls,
    CommonSelect = _ref$Controls.CommonSelect,
    Select = _ref$Controls.Select,
    Text = _ref$Controls.Text,
    notEmpty = _ref.validators.notEmpty;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _ref2 = zipCodeField || {
      validator: notEmpty,
      message: 'Please enter your zip code.'
    },
    zipCodeValid = _ref2.validator,
    zipCodeMessage = _ref2.message;
  var optional = function optional(value) {
    return value === '';
  };
  var optionalZipCode = function optionalZipCode(value) {
    return optional(value) || zipCodeValid(value);
  };
  var _ref3 = phoneValidation || {
      validator: notEmpty,
      message: 'Phone number is required',
      description: null,
      minLength: 7,
      maxLength: 25
    },
    phoneValid = _ref3.validator,
    phoneMessage = _ref3.message,
    phoneDesc = _ref3.description,
    phoneMinLength = _ref3.minLength,
    phoneMaxLength = _ref3.maxLength;
  var country = useWatch({
    name: "".concat(name, "[country]")
  });
  var state = useWatch({
    name: "".concat(name, "[state]")
  });
  var methods = useFormContext();
  var defaultCountry = useSelector(getDefaultCountry);
  var countries = useSelector(function (_ref4) {
    var account = _ref4.account,
      payment = _ref4.payment;
    return selectableCountries || (account.countries.length > 0 ? account.countries : payment.countries);
  });
  var statesAsSelect = (country === null || country === void 0 || (_country$states = country.states) === null || _country$states === void 0 ? void 0 : _country$states.length) > 0;
  useEffect(function () {
    var _country$states2;
    if (!country) {
      return;
    }
    if (state && statesAsSelect && !country.states.find(function (s) {
      return s.value === state.value;
    })) {
      methods.setValue("".concat(name, "[state]"), '', {
        shouldDirty: true
      });
    } else if (state && (country === null || country === void 0 || (_country$states2 = country.states) === null || _country$states2 === void 0 ? void 0 : _country$states2.length) === 0 && state.value) {
      methods.setValue("".concat(name, "[state]"), state.value, {
        shouldDirty: true
      });
    }
  }, [country === null || country === void 0 ? void 0 : country.value]);
  useEffect(function () {
    if (philDefaultCountry) {
      methods.setValue("".concat(name, "[country]"), defaultCountry);
    }
  }, [defaultCountry === null || defaultCountry === void 0 ? void 0 : defaultCountry.value]);
  useEffect(function () {
    if (!address || !countries) {
      return;
    }
    populatePaymentAddress(address);
  }, [address === null || address === void 0 ? void 0 : address.id, countries === null || countries === void 0 ? void 0 : countries.length]);
  var populatePaymentAddress = function populatePaymentAddress(rawAddress) {
    var address = convertRawAddressToFormData({
      countries: countries,
      defaultValues: defaultValues,
      rawAddress: rawAddress
    });
    methods.setValue("".concat(name), address, {
      shouldDirty: true
    });
    methods.setValue("".concat(name, "[country]"), address.country, {
      shouldDirty: true
    });
    methods.setValue("".concat(name, "[state]"), address.state, {
      shouldDirty: true
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "row address-form"
  }, displayHeader ? /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("legend", null, /*#__PURE__*/React.createElement(T, {
    source: "".concat(type, " information")
  }))) : null, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, enableAddressSelection ? /*#__PURE__*/React.createElement(CommonSelect, {
    isClearable: false,
    className: "previous-address-selector dropdown",
    placeholder: t('Select A Previous Address'),
    options: addressOptions,
    value: address ? address.id : null,
    onChange: function onChange(sel) {
      return populatePaymentAddress(sel.address);
    }
  }) : null, nameField ? /*#__PURE__*/React.createElement(Text, {
    label: nameField,
    maxLength: "50",
    messages: {
      notEmpty: 'Customer name is required'
    },
    name: "".concat(name, "[name]"),
    styles: styles,
    validators: {
      notEmpty: notEmpty
    }
  }) : null, phoneField ? /*#__PURE__*/React.createElement(Text, {
    description: phoneDesc,
    label: "Phone number",
    maxLength: phoneMaxLength,
    messages: {
      phoneValid: phoneMessage
    },
    minLength: phoneMinLength,
    name: "".concat(name, "[phone]"),
    styles: styles,
    validators: {
      phoneValid: phoneValid
    }
  }) : null, organizationField ? /*#__PURE__*/React.createElement(Text, {
    description: organizationFieldDescription,
    label: organizationFieldLabel,
    maxLength: "60",
    messages: {
      notEmpty: /*#__PURE__*/React.createElement(T, {
        source: organizationFieldErrorMessage
      })
    },
    name: "".concat(name, "[organization]"),
    styles: styles,
    validators: organizationFieldRequired ? {
      notEmpty: notEmpty
    } : undefined
  }) : null, /*#__PURE__*/React.createElement(Text, {
    label: "".concat(type, " address"),
    maxLength: "100",
    messages: {
      notEmpty: 'Please enter your address.'
    },
    name: "".concat(name, "[address1]"),
    placeholder: "Address line 1",
    styles: styles,
    validators: {
      notEmpty: notEmpty
    }
  }), /*#__PURE__*/React.createElement(Text, {
    maxLength: "100",
    name: "".concat(name, "[address2]"),
    placeholder: "Address line 2",
    styles: styles
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 col-12"
  }, /*#__PURE__*/React.createElement(Text, {
    label: "City",
    messages: {
      notEmpty: 'Please enter your city.'
    },
    name: "".concat(name, "[city]"),
    validators: {
      notEmpty: notEmpty
    },
    styles: styles,
    maxLength: "40"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 col-12"
  }, statesAsSelect ? /*#__PURE__*/React.createElement(Select, {
    label: "State",
    messages: {
      notEmpty: 'Please choose your state.'
    },
    name: "".concat(name, "[state]"),
    validators: {
      notEmpty: notEmpty
    },
    styles: styles,
    options: country.states
  }) : /*#__PURE__*/React.createElement(Text, {
    label: "State / Province / Region",
    name: "".concat(name, "[state]"),
    styles: styles,
    maxLength: "30",
    required: false,
    validators: {}
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 col-12"
  }, /*#__PURE__*/React.createElement(Text, {
    label: "Zip / Postal Code",
    messages: {
      zipCodeValid: zipCodeMessage
    },
    name: "".concat(name, "[zip]"),
    validators: required ? {
      zipCodeValid: zipCodeValid
    } : {
      optionalZipCode: optionalZipCode
    },
    required: required,
    styles: styles,
    maxLength: "9"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 col-12"
  }, /*#__PURE__*/React.createElement(Select, {
    label: "Country",
    messages: {
      notEmpty: 'Please choose your country.'
    },
    name: "".concat(name, "[country]"),
    validators: {
      notEmpty: notEmpty
    },
    styles: styles,
    options: countries
  })), vatField ? /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(Text, {
    label: "VAT (or other tax code)",
    name: "".concat(name, "[vat]"),
    styles: styles
  })) : null);
};
export default AddressForm;